
import { Entity, Index, PrimaryColumn, Column, BaseEntity } from "typeorm";

@Entity({ name: 'parking_tickets' }) 
@Index(['business_id', 'location_id', 'id'])
@Index(['business_id', 'location_id', 'last_modified'])
@Index(['business_id', 'location_id', 'isSynced'])
@Index(['business_id', 'location_id', 'code', 'vehicle_plate_number', 'contact_name', 'contact_phone'])
export class ParkingTicket extends BaseEntity {
  @PrimaryColumn()
  id: string;

  @Column() 
  @Index()
  business_id: string;

  @Column() 
  @Index()
  location_id: string;

  @Column({ nullable: true })
  @Index()
  operator_id: string;

  @Column({ nullable: true })
  @Index()
  parking_lot_id: string;

  @Column() 
  @Index()
  code: string;

  @Column() 
  @Index()
  vehicle_plate_number: string;

  @Column() 
  vehicle_color: string;

  @Column({ nullable: true })
  vehicle_make: string;

  @Column({ nullable: true }) 
  contact_name: string;

  @Column({ nullable: true }) 
  contact_phone: string;

  @Column({ default: 'in' })
  status: string;

  @Column({ nullable: true })
  entered_at: Date;

  @Column({ nullable: true })
  exited_at: Date;

  @Column({ type: 'text', nullable: true })
  metadata: string;

  @Column()
  created_at: Date;

  @Column({ nullable: true })
  updated_at: Date;

  @Column({ type: 'bigint', nullable: true })
  @Index()
  last_modified: number;

  @Column({ default: false })
  @Index()
  isSynced: boolean;
}